import React from 'react';
import styles from './Footer.module.css';
import icApk from "../assets/icon/ic_apk_store.svg";
import icPlayStore from "../assets/icon/ic_play_store.svg";
import logo from "../assets/icon/footer_logo.svg";
import logoText from "../assets/icon/footer_logo_text.svg";
import socialX from "../assets/icon/sat_social_x.svg";
import socialT from "../assets/icon/sat_social_telegram.svg";
import socialD from "../assets/icon/sat_social_discord.svg";
import socialM from "../assets/icon/sat_social_medium.svg";
import socialL from "../assets/icon/sat_social_linkedin.svg";
import {useTranslation} from "react-i18next";
import icApp from "../assets/icon/ic_app_store.svg";


interface MenuColumn {
    title: string;
    items: string[];
    link?: string;
}

const Footer: React.FC = () => {
    const {t} = useTranslation();

    const menuColumns: MenuColumn[] = [
        {title: t('discover'), items: [t('freeAirdrops')], link: 'https://satoshiapp.xyz/en/airdrop'},
        {title: t('listAirdrops'), items: [t('whySatoshiApp'), 'Showcases'], link: 'https://satoshiapp.xyz/en/collaboration'},
        {title: t('aboutUs'), items: [t('companyOverview')], link: "https://satoshiapp.xyz/en/overview"},
        {title: t('media'), items: [t('blog')], link: 'https://satoshiapp.xyz/en/media'},
        {title: t('support'), items: [t('footerFaq')], link: 'https://satoshiapp.xyz/en/support'},
    ];

    const socialIcons = [
        {src: socialX, alt: 'X', link: "https://x.com/SatoshiAppXYZ"},
        {src: socialT, alt: 'Telegram', link: "https://t.me/SatoshiAppXYZ"},
        {src: socialD, alt: 'Discord', link: "https://discord.com/invite/Nsyk6Q6hrM"},
        {src: socialM, alt: 'Medium', link: "https://satoshiappxyz.medium.com/"},
        {src: socialL, alt: 'LinkedIn', link: "https://www.linkedin.com/company/satoshiapp/about/"},
    ];

    /*const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
    const [isTermsOpen, setIsTermsOpen] = useState(false);

    const openPrivacy = (e: any) => {
        e.preventDefault();
        setIsPrivacyOpen(true);
    };

    const closePrivacy = () => {
        setIsPrivacyOpen(false);
    };

    const openTerms = (e: any) => {
        e.preventDefault();
        setIsTermsOpen(true);
    };

    const closeTerms = () => {
        setIsTermsOpen(false);
    };*/

    return (
        <footer className={styles.footerContent}>
            <div className={styles.footerRow}>
                <section className={styles.downloadSection}>
                    <div className={styles.logoContainer} onClick={() => {
                        window.open('https://satoshiapp.xyz', '_blank');
                    }}>
                        <div className={styles.logoWrapper}>
                            <img loading="lazy"
                                 src={logo}
                                 className={styles.logoIcon} alt="Satoshi App Icon"/>
                            <img loading="lazy"
                                 src={logoText}
                                 className={styles.logoText} alt="Satoshi App"/>
                        </div>
                    </div>
                    <div className={styles.downloadContainer}>
                        <div className={styles.downloadText}>{t('downloadSatoshiApp')}</div>
                        <div className={styles.storeButtons}>
                            <div className={styles.appStoreButton}>
                                <img onClick={() => {
                                    window.open('https://satoshiapp.xyz/en/download-app', '_blank');
                                }}
                                     src={icApk}
                                     className={styles.appStoreImage} alt="Download on the App Store"/>
                            </div>
                            <img onClick={() => {
                                window.open('https://play.google.com/store/apps/details?id=com.sat21.global.pro', '_blank');
                            }}
                                 src={icPlayStore}
                                 className={styles.playStoreImage} alt="Get it on Google Play"/>
                            <img src={icApp} style={{height: 32, width: 106}} onClick={() => {
                                window.open('https://apps.apple.com/app/satoshi-app-get-airdrops/id6736825074', '_blank');
                            }}/>
                        </div>
                    </div>
                </section>
                <nav className={styles.footerMenu}>
                    {menuColumns.map((column, index) => (
                        <div key={index} className={styles.menuColumn}>
                            <span className={styles.menuTitle}>{column.title}</span>
                            {column.items.map((item, itemIndex) => (
                                <a key={itemIndex} href={column.link} className={styles.menuItem} target="_blank">
                                    {item}
                                </a>
                            ))}
                        </div>
                    ))}
                </nav>
            </div>
            <div className={styles.divider}>
                <div className={styles.dividerLine}/>
            </div>
            <div className={styles.footerBottom}>
                <section className={styles.communitySection}>
                    <h3 className={styles.communityText}>{t('joinCommunity')}</h3>
                    <div className={styles.socialIcons}>
                        {socialIcons.map((icon, index) => (
                            <a key={index} href={icon.link} aria-label={`Visit our ${icon.alt} page`} target="_blank">
                                <img loading="lazy" src={icon.src} className={styles.socialIcon} alt={icon.alt}/>
                            </a>
                        ))}
                    </div>
                </section>
                <section className={styles.copyrightSection}>
                    <p className={styles.copyrightText}>© 2024 {t('satoshiApp')}</p>
                    <div className={styles.legalLinks}>
                        <a href="https://satoshiapp.xyz/en/privacy-policy" target="_blank">{t('privacyPolicy')}</a>
                        <a href="https://satoshiapp.xyz/en/terms-of-use" target="_blank">{t('terms')}</a>
                    </div>
                </section>
            </div>

            {/*<a href="#" onClick={openPrivacy}>{t('privacyPolicy')}</a>
            <a href="#" onClick={openPrivacy}>{t('terms')}</a>
            {isPrivacyOpen && (
                <div className={styles.modal}>
                    <div className={styles.modalContent}>
                        <img
                            src={icClose}
                            alt="Close"
                            className={styles.closeButton}
                            onClick={closePrivacy}
                        />

                        <h2>{t('privacyPolicy')}</h2>
                        <div className={styles.modalBody}>
                            <p>{t('privacy')}</p>
                        </div>
                    </div>
                </div>
            )}*/}

        </footer>
    );
};

export default Footer;